<template>
  <div id="blade6">
    <div class="bladeContainer">
      <GroupContainer :obj="stObj.gC">
        <template slot="slot1">
          <TwelveCol>
            <template slot="slot1">
              <h2
                class="blade-6-headline"
                slot="slot1"
                v-html="stObj.title"
                data-aos="fade-left"
                data-aos-delay="2000"
              ></h2>

              <SixBySix>
                <div class="col" slot="slot1" id="div1">
                  <p
                    class="body blade-6-p"
                    v-for="(p, index) in stObj.paragraphs"
                    v-html="p"
                    :key="`blade3-p-${index}`"
                    data-aos="fade-up"
                    data-aos-delay="2000"
                  ></p>
                </div>
                <div slot="slot2" id="div2">
                  <div class="blade-6-px">
                    <p
                      class="blade-6-title"
                      data-aos="fade-up"
                      data-aos-delay="3000"
                      v-html="stObj.findOutTitle"
                    ></p>

                    <div
                      data-aos="fade-up"
                      data-aos-delay="3000"
                      class="learnmoreCTA vz-button-link"
                      tabindex="10"
                      @click="learnMore"
                      @keyup.enter="learnMore"
                      :aria-label="stObj.learnMoreTitle"
                      :data-loc="'Content:Button:Off-the-charts disruption:'+stObj.learnMoreTitle">
                      <svg width="180px" height="50px" viewBox="-2 -2 180 50" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                        <path class="learnmoreCTAbutton" d="M20.999 0L139.001 0Q139.516 0 140.031 0.0252942Q140.546 0.0505884 141.059 0.101116Q141.572 0.151643 142.082 0.227282Q142.592 0.302921 143.098 0.40349Q143.603 0.504058 144.103 0.629314Q144.603 0.754569 145.097 0.90421Q145.59 1.05385 146.075 1.22752Q146.561 1.40118 147.037 1.59845Q147.513 1.79573 147.979 2.01613Q148.445 2.23653 148.9 2.47954Q149.354 2.72254 149.797 2.98756Q150.239 3.25257 150.667 3.53897Q151.096 3.82536 151.51 4.13244Q151.924 4.43953 152.323 4.76655Q152.721 5.09358 153.103 5.43977Q153.485 5.78595 153.85 6.15046Q154.214 6.51498 154.56 6.89693Q154.906 7.27889 155.233 7.67738Q155.56 8.07586 155.868 8.48991Q156.175 8.90396 156.461 9.33258Q156.747 9.7612 157.012 10.2034Q157.277 10.6455 157.52 11.1001Q157.763 11.5548 157.984 12.0208Q158.204 12.4868 158.402 12.963Q158.599 13.4393 158.772 13.9246Q158.946 14.41 159.096 14.9033Q159.245 15.3966 159.371 15.8967Q159.496 16.3967 159.596 16.9023Q159.697 17.4079 159.773 17.9178Q159.848 18.4277 159.899 18.9407Q159.949 19.4538 159.975 19.9686Q160 20.4835 160 20.999L160 21.001Q160 21.5165 159.975 22.0314Q159.949 22.5462 159.899 23.0593Q159.848 23.5723 159.773 24.0822Q159.697 24.5921 159.596 25.0977Q159.496 25.6033 159.371 26.1033Q159.245 26.6034 159.096 27.0967Q158.946 27.59 158.772 28.0753Q158.599 28.5607 158.402 29.037Q158.204 29.5132 157.984 29.9792Q157.763 30.4452 157.52 30.8999Q157.277 31.3545 157.012 31.7966Q156.747 32.2388 156.461 32.6674Q156.175 33.096 155.868 33.5101Q155.56 33.9241 155.233 34.3226Q154.906 34.7211 154.56 35.1031Q154.214 35.485 153.85 35.8495Q153.485 36.214 153.103 36.5602Q152.721 36.9064 152.323 37.2334Q151.924 37.5605 151.51 37.8675Q151.096 38.1746 150.667 38.461Q150.239 38.7474 149.797 39.0124Q149.354 39.2775 148.9 39.5205Q148.445 39.7635 147.979 39.9839Q147.513 40.2043 147.037 40.4015Q146.561 40.5988 146.075 40.7725Q145.59 40.9461 145.097 41.0958Q144.603 41.2454 144.103 41.3707Q143.603 41.4959 143.098 41.5965Q142.592 41.6971 142.082 41.7727Q141.572 41.8484 141.059 41.8989Q140.546 41.9494 140.031 41.9747Q139.516 42 139.001 42L20.999 42Q20.4835 42 19.9686 41.9747Q19.4538 41.9494 18.9407 41.8989Q18.4277 41.8484 17.9178 41.7727Q17.4079 41.6971 16.9023 41.5965Q16.3967 41.4959 15.8967 41.3707Q15.3966 41.2454 14.9033 41.0958Q14.41 40.9461 13.9246 40.7725Q13.4393 40.5988 12.963 40.4015Q12.4868 40.2043 12.0208 39.9839Q11.5548 39.7635 11.1001 39.5205Q10.6455 39.2775 10.2034 39.0124Q9.7612 38.7474 9.33258 38.461Q8.90396 38.1746 8.48991 37.8675Q8.07586 37.5605 7.67738 37.2334Q7.27889 36.9064 6.89693 36.5602Q6.51498 36.214 6.15046 35.8495Q5.78595 35.485 5.43977 35.1031Q5.09358 34.7211 4.76655 34.3226Q4.43953 33.9241 4.13244 33.5101Q3.82536 33.096 3.53897 32.6674Q3.25257 32.2388 2.98756 31.7966Q2.72254 31.3545 2.47954 30.8999Q2.23653 30.4452 2.01613 29.9792Q1.79573 29.5132 1.59845 29.037Q1.40118 28.5607 1.22752 28.0753Q1.05385 27.59 0.90421 27.0967Q0.754569 26.6034 0.629314 26.1033Q0.504058 25.6033 0.40349 25.0977Q0.302921 24.5921 0.227282 24.0822Q0.151643 23.5723 0.101116 23.0593Q0.0505884 22.5462 0.0252942 22.0314Q0 21.5165 0 21.001L0 20.999Q0 20.4835 0.0252942 19.9686Q0.0505884 19.4538 0.101116 18.9407Q0.151643 18.4277 0.227282 17.9178Q0.302922 17.4079 0.40349 16.9023Q0.504058 16.3967 0.629314 15.8967Q0.754569 15.3966 0.90421 14.9033Q1.05385 14.41 1.22752 13.9246Q1.40118 13.4393 1.59845 12.963Q1.79573 12.4868 2.01613 12.0208Q2.23653 11.5548 2.47954 11.1001Q2.72254 10.6455 2.98756 10.2034Q3.25258 9.7612 3.53897 9.33258Q3.82536 8.90396 4.13244 8.48991Q4.43953 8.07586 4.76655 7.67738Q5.09358 7.27889 5.43977 6.89693Q5.78595 6.51498 6.15047 6.15046Q6.51498 5.78595 6.89693 5.43977Q7.27889 5.09358 7.67738 4.76655Q8.07586 4.43953 8.48991 4.13244Q8.90396 3.82536 9.33258 3.53897Q9.7612 3.25257 10.2034 2.98756Q10.6455 2.72254 11.1001 2.47954Q11.5548 2.23653 12.0208 2.01613Q12.4868 1.79573 12.963 1.59845Q13.4393 1.40118 13.9246 1.22752Q14.41 1.05385 14.9033 0.90421Q15.3966 0.754569 15.8967 0.629314Q16.3967 0.504058 16.9023 0.40349Q17.4079 0.302921 17.9178 0.227282Q18.4277 0.151643 18.9407 0.101116Q19.4538 0.0505884 19.9686 0.0252942Q20.4835 0 20.999 0L20.999 0Z" stroke="#000000" stroke-width="1" fill="none" />
                      </svg>

                      <p class="learnmoreCTAbody" v-html="stObj.learnMoreTitle"></p>
                    </div>
                  </div>
                </div>
              </SixBySix>
            </template>
          </TwelveCol>
        </template>
      </GroupContainer>

      <img
        :src="stObj.womanImage"
        class="womanImage"
        id="womanImage"
        :alt="stObj.womanImageAltText"
      />
      <img :src="stObj.treeImage" class="treeImage" id="treeImage" />
    </div>
  </div>
</template>

<script>
import GroupContainer from "../../2019-immersive-modular-experience/src/components/GroupContainer";
import SixBySix from "../../2019-immersive-modular-experience/src/components/SixBySix.vue";
import TwelveCol from "../../2019-immersive-modular-experience/src/components/TwelveCol";
import { inView } from "../helpers/inView";
import { womanAnimation } from "../helpers/blade6";

export default {
  name: "Blade6",
  data: function() {
    return {
      sPW: 0,
      hasAnimated: false
    };
  },
  components: {
    GroupContainer,
    SixBySix,
    TwelveCol
  },
  computed: {
    stObj() {
      return this.$store.state.blade6;
    }
  },
  methods: {
    checkInView() {
      if (!this.hasAnimated) {
        this.hasAnimated = inView("#womanImage", womanAnimation, "topvisible");
      } else {
        document.removeEventListener("scroll", this.checkInView);
      }
    },
    learnMore() {
      location.href =
        "https://enterprise.verizon.com/business/learn/edge-computing/";
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.checkInView();
      document.addEventListener("scroll", this.checkInView);
    });
  },
  destroyed() {
    document.removeEventListener("scroll", this.checkInView);
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/blade6.scss";
</style>